import { Badge } from "@/core/components/ui/badge";
import { NoTranslate } from "@/core/components/ui/no-translate";
import type { ApprovalStatus } from "@/features/shared/api/enums";

const STATUS_VARIANTS: Record<
  ApprovalStatus,
  "warning" | "success" | "secondary" | "destructive" | "default"
> = {
  PENDING: "warning",
  APPROVED: "default",
  REJECTED: "destructive",
  CANCELLED: "secondary",
  APPLIED: "success",
  FAILED: "destructive",
};

/** Badge de statut d'une demande d'approbation (valeur brute, NoTranslate). */
export function ApprovalRequestStatusBadge({
  status,
}: {
  status?: ApprovalStatus;
}) {
  if (!status) return <span>—</span>;
  return (
    <NoTranslate as="span">
      <Badge variant={STATUS_VARIANTS[status] ?? "outline"}>{status}</Badge>
    </NoTranslate>
  );
}
